import { render, staticRenderFns } from "./search-database-experimental.vue?vue&type=template&id=56eb0a5f&"
import script from "./search-database-experimental.vue?vue&type=script&lang=js&"
export * from "./search-database-experimental.vue?vue&type=script&lang=js&"
import style0 from "./search-database-experimental.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports